import React from 'react'

function SecuritiesAmerica() {

    return (
        <div>
            <p>
                Securities America serves as our Broker-Dealer and Registered Investment Advisory and as the
                “back office” to Lifetime Capital. Their role is to provide independent financial advisors like
                myself, leading technology, practice management and business tools to help me manage my
                practice. They offer practice management support as well as operational support and
                compliance oversight.
            </p>
            <p> 
                Securities America is a wholly owned subsidiary of the Advisor Group. Lifetime Capital Financial
                Group and Securities America are separate entities.
            </p>
        </div>
    )
}
export default SecuritiesAmerica